import { IImage } from '../../types';

/** The cart line item's thumbnail. */
export const GIFT_CARD_CART_IMAGE: IImage = {
  type: 'image',
  url: '/gift_card/yellow_card.jpg',
  retinaWidth: 1500,
  retinaHeight: 1125,
};

export interface GiftCardSlide {
  image: IImage;
  /** A 768x350 crop for the full-bleed stage on tablets, where the square-ish slide would letterbox. */
  wideImage?: IImage;
  /** Photo slides fill the stage; the transparent cut-out sits on the gray instead. */
  photo: boolean;
}

const slideImage = (url: string): IImage => ({ type: 'image', url, retinaWidth: 2000, retinaHeight: 1644 });
const wideImage = (url: string): IImage => ({ type: 'image', url, retinaWidth: 1536, retinaHeight: 700 });

export const GIFT_CARD_SLIDES: GiftCardSlide[] = [
  {
    image: { type: 'image', url: '/gift_card/paw_card.png', retinaWidth: 1500, retinaHeight: 1233 },
    photo: false,
  },
  {
    image: slideImage('/gift_card/slide_ultra.jpg'),
    wideImage: wideImage('/gift_card/slide_ultra_wide.jpg'),
    photo: true,
  },
  {
    image: slideImage('/gift_card/slide_series3.jpg'),
    wideImage: wideImage('/gift_card/slide_series3_wide.jpg'),
    photo: true,
  },
  {
    image: slideImage('/gift_card/slide_mini.jpg'),
    wideImage: wideImage('/gift_card/slide_mini_wide.jpg'),
    photo: true,
  },
];
